import {Ref} from 'vue'
import {useMediaQuery} from '@vueuse/core';

export const useMobileDetector = (): Ref<boolean> => {
  return useMediaQuery('only screen and (max-width: 767px)');
};

export const useTabletDetector = (): Ref<boolean> => {
  return useMediaQuery('only screen and (min-width: 768px) and (max-width: 1023px)');
};

export const useDesktopDetector = (): Ref<boolean> => {
  return useMediaQuery('only screen and (min-width: 1024px)');
};

export const useDarkScheme = (): Ref<boolean> => {
  return useMediaQuery('(prefers-color-scheme: dark)');
};
